import { render } from "./Kisiler.vue?vue&type=template&id=367c59ee&scoped=true"
import script from "./Kisiler.vue?vue&type=script&lang=js"
export * from "./Kisiler.vue?vue&type=script&lang=js"

import "./Kisiler.vue?vue&type=style&index=0&id=367c59ee&scoped=true&lang=css"

import exportComponent from "/home/umut/Desktop/tm-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-367c59ee"]])

export default __exports__